export default "__VITE_ASSET__49719e1b__"